<template>
  <div>
    <dashboard-header :text="$t('user.changePassword')" :on-back="onGoBack"/>
    <div class="d-flex align-content-center justify-content-center">
      <v-card
          elevation="0"
          :loading="loading"
          class="card-border-10 mx-16 w-75">
        <v-card-title class="ml-1">
          {{ departmentName }}
        </v-card-title>
        <v-divider style="margin-top: 0px;"></v-divider>
        <div class="pa-5">
          <data-detail
              data-colon
              :items="items"
              :simple-header="header"
          />
        </div>
        <v-card
            outlined
            class=" m-4 card-border-10">
          <p class="p-3 m-0 text-sm-h5 custom-card-head ">{{ $t("ui.changePassword") }}</p>
          <v-divider class="mt-0" style="border-color: #D9D9D9"></v-divider>

          <v-form v-model="isFormValid">
            <div>
              <div class="d-flex">
                <div class="text-h6 mark-title ms-3">*</div>
                <p class="ms-1 text-body-1">{{ $t("ui.newPassword") }}</p>
              </div>
              <v-text-field
                  class="mx-3"
                  v-model="newPassword"
                  outlined
                  dense
                  placeholder="••••••••"
                  :type="passwordType"
                  :rules="rulePassWord"
                  persistent-hint
                  required
              >
                <template v-slot:append>
                  <a>
                    <img
                        style="margin-top: 4px"
                        @click="onShowPass"
                        width="16"
                        height="16"
                        :src="
                        passwordType === 'password'
                            ? require('@/assets/images/ic-pw-hide.svg')
                            : require('@/assets/images/ic-pw-show.svg')
                    ">
                  </a>
                </template>

              </v-text-field>

              <div class="d-flex">
                <div class="text-h6 mark-title ms-3">*</div>
                <p class="ms-1 text-body-1">{{ $t("ui.newPasswordAgain") }}</p>
              </div>
              <v-text-field
                  class="mx-3"
                  v-model="newPasswordAgain"
                  outlined
                  dense
                  placeholder="••••••••"
                  :type="passwordAgainType"
                  :rules="rulePassWordAgain"
                  required
              >
                <template v-slot:append>
                  <a>
                    <img
                        style="margin-top: 4px"
                        @click="onShowPassAgain"
                        width="16"
                        height="16"
                        :src="
                        passwordAgainType === 'password'
                            ? require('@/assets/images/ic-pw-hide.svg')
                            : require('@/assets/images/ic-pw-show.svg')
                    ">
                  </a>
                </template>
              </v-text-field>
              <!-- <div v-if="validPasswordMsg" style="margin-top: -20px" class="mark-title text-body-2 ms-3">
                {{ validPasswordMsg }}
              </div> -->

              <v-btn
                  :disabled="!isFormValid || !validChangePassword || validPasswordMsg !== '' "
                  class="ms-3 mt-3 mb-5 no-uppercase"
                  elevation="0"
                  @click="onChangePass"
                  color="info">
                {{ $t("ui.save") }}
              </v-btn>

            </div>
          </v-form>

        </v-card>

      </v-card>
    </div>
  </div>
</template>

<script>
import DashboardHeader from "../component/DashboardHeader";
import DataDetail from "../base/DataDetail.vue";
import mixin from "../../mixin";
import {API2} from "../../api";
import i18n from "../../lang/i18n";

export default {
  name: "ChangePassword",
  components: {DashboardHeader, DataDetail},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      detail: null,
      isFormValid: false,
      passwordType: 'password',
      passwordAgainType: 'password',
      newPassword: null,
      newPasswordAgain: null,
    };
  },
  computed: {
    departmentName() {
      return this.detail?.name
    },
    header() {
      return this.$t('ui.caption')
    },
    items() {
      return [
        {
          title: i18n.t("ui.nameDepartment"),
          data: this.detail?.dpInchargeEmployeeName
        },
        {
          title: i18n.t("ui.email"),
          data: this.detail?.dpEmail
        },
      ]
    },
    rulePassWord() {
      return [
        this.newPassword && this.newPassword.length >= 8
        && /[A-Z]/.test(this.newPassword)
        && /[!@#$%^&*(),.?":{}|<>]/.test(this.newPassword)
        && /[0-9]/.test(this.newPassword)
        && !/\s/.test(this.newPassword)
        || this.$t("ui.MSG0039"),
      ]
    },
    rulePassWordAgain() {
      return [
        this.newPasswordAgain === this.newPassword || this.$t('ui.passwordNotMatch'),
        // this.newPasswordAgain && this.newPasswordAgain.length >= 8
        // && /[A-Z]/.test(this.newPasswordAgain)
        // && /[!@#$%^&*(),.?":{}|<>]/.test(this.newPasswordAgain)
        // && /[0-9]/.test(this.newPasswordAgain)
        // && !/\s/.test(this.newPasswordAgain)
        // || this.$t("ui.MSG0039"),
      ]
    },
    validChangePassword: function () {
      return this.newPassword && this.newPasswordAgain
    },
    validPasswordMsg() {
      return this.newPassword === this.newPasswordAgain || this.newPasswordAgain === '' ? '' : this.$t('ui.passwordNotMatch')
    },
  },
  mounted() {
    this.onTab(this.item)
  },
  methods: {
    onTab(item) {
      this.newPassword = null
      this.newPasswordAgain = null
      this.getData(item)
    },
    async getData(item) {
      this.detail = null
      let res = await this.get(API2.DEPARTMENT, {path: item.data.departmentId})
      if (res) this.detail = res
    },
    async onChangePass() {
      let changePassRes = await this.put(API2.EMPLOYEE_CHANGE_PASSWORD, {
        email: this.detail.dpEmail,
        password: this.newPassword,
        confirmPassword: this.newPasswordAgain,
      })
      if (!changePassRes) return
      this.showToast("success", this.$t('ui.passwordChangeSuccess'), '')
      this.openTab(0)
    },
    onGoBack() {
      this.openTab(0)
    },
    onShowPass() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    onShowPassAgain() {
      this.passwordAgainType = this.passwordAgainType === "password" ? "text" : "password";
    },
  }
}
</script>

<style scoped>

.card-border-10 >>> .text-sm-h5 {
  font-size: 20px !important;
}
</style>

